
import { getWordpressPostBySlug, getWordpressPostListRelated } from "@src/functions/wordpress";
import WordpressPost from "../common/components/WordpressPost";

export async function getServerSideProps(context: any) {
  const { post } = context.query;
  const postJson = await getWordpressPostBySlug(post);
  const relatedJson = await getWordpressPostListRelated("1389");

  return {
    props: { data: Array.isArray(postJson) ? postJson[0] : postJson, related: relatedJson, group: "recycling" },
  }
}

function Post ({ data, related, group }: any) {
  return (
    <WordpressPost data={data} related={related} group={group} />
  );
};

export default Post;